import { PropsWithChildren } from 'react';

import './FormControl.scss';

export const FormControl = ({
    label,
    isMandatory,
    children,
    className,
}: { label?: string; isMandatory?: boolean; className?: string } & PropsWithChildren) => (
    <div className={`form-control ${className || ''}`}>
        {label ? (
            <span className="form-control__label">
                {label}
                {isMandatory && <span className="form-control__required-field"> *</span>}
            </span>
        ) : null}
        {children}
    </div>
);
